<template>
    <div class="parents">

         <!-- <div class="steps">
            <div class="steps_top">
                <img class="steps_bar_size" :src="imagePath+'/info_entry.png'"/>
            </div>
        </div> -->

        <div class="prompt">
            <div class="prompt_title">
                <span class="prompt_title_sub">请输入车牌号码</span>
            </div>
        </div>
        <div class="plate_num">
            <div class="plate_num_input" @click="keyboard">
				<plateNumber :keyBoardShow="keyboardActive" @getPlateLicense="getPlateLicense"></plateNumber>
            </div>

            <div class="plate_num_option">
                <ul class="plate_num_outter">
                    <li>
                        <div class="inline_block_top btn_color color_yellow" @click="chooseColor(1)">
                            <!-- <span :class="(issuePlateCheck.plateColor == 1 ? 'circle' : '')"/> -->
                            <span v-show="issuePlateCheck.plateColor == 1">
                                <i class="cubeic-right"></i>
                            </span>
                        </div>
                    </li>
                    <li>
                        <div class="inline_block_top btn_color color_blue" @click="chooseColor(0)">
                            <!-- <span :class="(issuePlateCheck.plateColor == 0 ? 'circle' : '')"/> -->
                            <span v-show="issuePlateCheck.plateColor == 0">
                                <i class="cubeic-right"></i>
                            </span>
                        </div>
                    </li>
                    <li>
                        <div class="inline_block_top btn_color color_large_newenergy" @click="chooseColor(5)">
                            <!-- <span :class="(issuePlateCheck.plateColor == 5 ? 'circle' : '')"/> -->
                            <span v-show="issuePlateCheck.plateColor == 5">
                                <i class="cubeic-right"></i>
                            </span>
                        </div>
                    </li>
                    <li>
                        <div class="inline_block_top btn_color color_energy" @click="chooseColor(4)">
                            <!-- <span :class="(issuePlateCheck.plateColor == 4 ? 'circle' : '')"/> -->
                            <span v-show="issuePlateCheck.plateColor == 4">
                                <i class="cubeic-right"></i>
                            </span>
                        </div>
                    </li>
                    <li>
                        <div class="inline_block_top btn_color color_black" @click="chooseColor(2)">
                            <!-- <span :class="(issuePlateCheck.plateColor == 2 ? 'circle' : '')"/> -->
                            <span v-show="issuePlateCheck.plateColor == 2">
                                <i class="cubeic-right"></i>
                            </span>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="hinting">
                <div class="hintting_line">
                    <img class="hintting_sign" :src="imagePath+'/hint.png'"/>
                    <span class="hintting_title">仅限货车用户办理</span>
                </div>
                <div class="hintting_line">
                    <img class="hintting_sign" :src="imagePath+'/hint.png'"/>
                    <span class="hintting_title">集卡在本平台办理的ETC卡无法进行集装箱优惠预约</span>
                </div>
            </div>

        </div>

         <div class="but_ton">
            <button class="next_btn" v-preventReClick @click="check">检测车辆是否可办理</button>
        </div>
        <!-- loding -->
            <!-- 遮罩层 -->
        <cube-popup type="my-popup" ref="myPopup"></cube-popup>
        <div class="show_loading">
            <cube-loading :size="60" v-show="show"></cube-loading>
        </div>
    </div>
</template>



<script>
import { axios } from '../../util/request'
import { log } from 'util'
const NEW_VEHICLE_ID = "NEW-VEHICLE-ID"
import plateNumber from '../plateNumber'
import { compileFunction } from 'vm'
export default {
    data(){
        return{
            keyboardActive:true,
            totpUser: process.env.TOTPUser,
            imagePath: process.env.BASES_IMG_PATH,
            bankCode:'001',
            productId:'001',
            secXtimer:'',
            issuePlateCheck:{
                userId:sessionStorage.getItem("USER-ID"),
                plateNum:'',
                plateColor: -1// plateColor 默认为1，影响显示蓝色车牌css背景样式。改为默认-1(即默认值)
            },
            vehicle:{
                userId:sessionStorage.getItem("USER-ID"),
                plateNum:'',
                plateColor:'',
            },
            vehInfo:{
                plateNum:'',
                plateColor: -1,
            },
            userVehicleQuery:{
                userId:sessionStorage.getItem("USER-ID"),
                vehicleId:''
            },
            chooseIn:{
                userId:sessionStorage.getItem("USER-ID"),
                plateNum:"",
                plateColor:"",
                totpUser:process.env.TOTPUser
            },
            checkOrder:{
                userId:sessionStorage.getItem("USER-ID"),//用户id
                plateNum:"",//车牌号码
                plateColor:""//车牌颜色
            },
            state:'',
            result:'',
            info:'',
            selectOrder:{
              plateNum:"",
              plateColor:"",
              userId:sessionStorage.getItem("USER-ID")
            },

            // loding 状态 
            show: false,
        }
    },
    
    methods:{
        // 取消下弹窗状态
        keyboard(){
            this.keyboardActive = true
        },
        //获取key
        getTopKey(vehicleId){
            axios.post("/Check/topKey",
            {
                // topUser
                totpUser: this.totpUser
            }
            ).then(data => {
                // 增信
                window.location.href=process.env.DHYB_PATH+"etcpage/toIncCredit?openId="+this.issuePlateCheck.userId+"&vehicleId="+vehicleId+"&bankCode="+this.bankCode+"&productId="+this.productId+"&totpUser="+this.totpUser+"&totpKey="+data; 
            }).catch(err=>{
              this.closeLoading();
            })
        },
        chooseColor(e){
            // 取消下弹窗状态
            this.keyboardActive = false;
            this.issuePlateCheck.plateColor = e;
            this.chooseIn.plateColor = e;
        },
        getPlateLicense(data){
            this.issuePlateCheck.plateNum = data;
            this.chooseIn.plateNum = data;
        },
        //车牌验证
        check(){
            this.openLoading();
            //车牌长度检查
            if (this.issuePlateCheck.plateNum.length < 7){
                console.log(this.issuePlateCheck.plateNum)
                this.createDialog("用户提示","车牌号长度错误")
            }else if(this.issuePlateCheck.plateColor === -1){
                this.createDialog("用户提示","请选择车牌颜色")
            }else if(this.issuePlateCheck.plateColor < 4 && this.issuePlateCheck.plateNum.length === 8 ){
                this.createDialog("用户提示","非新能源车牌号长度为7位！")
            }else if(this.issuePlateCheck.plateColor === 4 && this.issuePlateCheck.plateNum.length < 8 ){
                this.createDialog("用户提示","新能源车牌号长度错误")
            }else if(this.issuePlateCheck.plateColor === 5 && this.issuePlateCheck.plateNum.length < 8 ){
                this.createDialog("用户提示","大型新能源车牌号长度错误")
            }else {
                this.next()
            }

        },
        
        //下一步
        next(){           
            axios.post("/IssueSupport/IssuePlateCheck",this.issuePlateCheck).then(data => {  
                console.log("车牌发行校验")
                console.log(data);                
                this.vehicle.plateNum = this.issuePlateCheck.plateNum;
                this.vehicle.plateColor = this.issuePlateCheck.plateColor;
                // 检查车辆是否绑定支付渠道的参数赋值
                this.checkOrder.plateNum = this.issuePlateCheck.plateNum;
                this.checkOrder.plateColor = this.issuePlateCheck.plateColor;


                sessionStorage.setItem(NEW_VEHICLE_ID,data.vehicleId);
                sessionStorage.setItem("PLATE-NUM",this.issuePlateCheck.plateNum);
                sessionStorage.setItem("PLATE-COLOR",this.issuePlateCheck.plateColor);

                this.selectOrder.plateNum = this.issuePlateCheck.plateNum;
                this.selectOrder.plateColor = this.issuePlateCheck.plateColor
                this.result = data.result;
                this.info = data.info;               
                this.vehicleLicense()
            }).catch(err=>{
              this.closeLoading();
            })
            

        },
        //判断是否跳到行驶证认证页面
        vehicleLicense(){                       
            switch (this.result) {
                case 1://1-	发行方已办理——在发行方单独办理的（分对分）
                    axios.post("/IssueSupport/CheckOrderIsBinding",this.checkOrder).then(data=>{
                        if(1==data.state){
                            this.$router.push({name:'obu'});
                        }else{
                            this.createDialog('1用户提示', this.info) 
                        }
                    }).catch(err=>{
                      this.closeLoading();
                    });       
                              
                    break;

                case 2://2-	统一平台办理——指的通过总队总部平台统一办理的
                    
                    axios.post("/IssueSupport/CheckOrderIsBinding",this.checkOrder).then(data=>{
                        if(1==data.state){
                            this.$router.push({name:'obu'});
                        }else{
                            this.createDialog('2用户提示', this.info) 
                        }
                    }).catch(err=>{
                      this.closeLoading();
                    });

                    break;

                case 3://3-	未关联，目前没有处理方式
                        
                    break;
                case 4://4-	未办理               
                    axios.post("/IssueSupport/CheckSteps",this.chooseIn).then(data=>{
                        console.log(data);
                        switch (data.state) {
                            case 0://车辆第一次进入
                                this.$router.push({name:'issue'});
                                break;
                            case 1://当系统中不存在预订单的时候
                                this.$router.push({name:'issue'});
                                break;
                            // case 2://当系统中存在预订单，但是预订单的vehicleId等车辆数据信息在部里已经无效的时候
                            //     this.$router.push({name:'issue'});
                            //     break;
                            // case 3://当预订单存在，且车辆信息有效，但是没有承保函信息的时候
                            //     window.location.href = process.env.DHYB_PATH+"etcpage/toIncCredit?openId="+sessionStorage.getItem("OPEN-ID")+"&vehicleId="+data.vehicleId+"&bankCode="+data.bankCode+"&productId="+data.productId+"&signWork="+process.env.SIGN_WORK+"&totpUser="+this.totpUser+"&totpKey="+data.totpKey;
                            //     break;
                            // case 4://当预订单存在，且车辆有效，且有有效的承保函信息的时候，但是该用户没有可用的支付渠道时候
                            //     this.createDialog('用户提示', "程序猿正在焦急等待银行签约开发完成中！急急急………………系统提示："+this.message) 
                            //     sessionStorage.setItem("BANK-CHANNEL-ID",data.channelId)
                            //     // window.location.href = data.signUrl;
                            //     break;
                            // case 5://当预订单存在，且车辆有效，且有有效的承保函信息的，该用户也有可用的支付渠道的时候                         
                            //     this.$router.push({name:'signing'});
                            //     break;
                            default:
                              this.createDialog('系统提示', "该车辆在当前系统中已经办理过，无法走新增流程，请选择车辆接着办理。")
                              break;
                        }
                    }).catch(err=>{
                      this.closeLoading();
                    });

                    break;    
                case 5://5-	办理中
                    axios.post("/IssueSupport/CheckSteps",this.chooseIn).then(data=>{
                        console.log(data);
                        switch (data.state) {
                            case 0://车辆第一次进入
                                this.createDialog('0用户提示0:请15分钟后再试', this.info)
                                break;
                            case 1://当系统中不存在预订单的时候
                                this.createDialog('1用户提示1:请15分钟后再试', this.info)
                                break;
                            // case 2://当系统中存在预订单，但是预订单的vehicleId等车辆数据信息在部里已经无效的时候
                            //     this.createDialog('2用户提示2:请15分钟后再试', this.info)
                            //     break;
                            // case 3://当预订单存在，且车辆信息有效，但是没有承保函信息的时候
                            //     window.location.href = process.env.DHYB_PATH+"etcpage/toIncCredit?openId="+sessionStorage.getItem("OPEN-ID")+"&vehicleId="+data.vehicleId+"&bankCode="+data.bankCode+"&productId="+data.productId+"&signWork="+process.env.SIGN_WORK+"&totpUser="+this.totpUser+"&totpKey="+data.totpKey;
                            //     break;
                            // case 4://当预订单存在，且车辆有效，且有有效的承保函信息的时候，但是该用户没有可用的支付渠道时候
                            //     this.createDialog('用户提示', "程序猿正在焦急等待银行签约开发完成中！急急急………………系统提示："+this.message) 
                            //     sessionStorage.setItem("BANK-CHANNEL-ID",data.channelId)
                            //     // window.location.href = data.signUrl;
                            //     break;
                            // case 5://当预订单存在，且车辆有效，且有有效的承保函信息的，该用户也有可用的支付渠道的时候                         
                            //     this.$router.push({name:'signing'});
                            //     break;
                            default:
                              this.createDialog('系统提示', "该车辆在当前系统中已经办理过，无法走新增流程，请选择车辆接着办理。")
                              break;
                        }
                    }).catch(err=>{
                      this.closeLoading();
                    });
                   
                    break;

                default://其他情况
                    this.createDialog('用户提示', "系统其他错误："+this.info)
                    break;
            }
        },
        openLoading(){
          if(this.secXtimer){
            clearTimeout(this.secXtimer);
          }
          if(this.$refs.myPopup){
            this.$refs.myPopup.show();
          }
          this.show = true;
          this.secXtimer = setTimeout(() => {
            if(this.$refs.myPopup){
                this.$refs.myPopup.hide();
                this.show = false;
            }
          }, 7000);
        },
        closeLoading(){
          if(this.$refs.myPopup){
            this.$refs.myPopup.hide();
          }
          this.show = false;
        },           
        createDialog(title,content){
          this.closeLoading();
          this.$createDialog({
            type: 'alert',
            title: title,
            content: content,
            icon: 'cubeic-alert'
          }).show()
        },
        getUserInfo() {
            if(!sessionStorage.getItem('USER-ID') && !sessionStorage.getItem('TOKEN-ID')) {
                this.$router.push({name: 'home'});
            }
        }
    //method ending 
    },
    mounted() {
        this.getUserInfo();
    },
    components: {
        plateNumber
    },
}
</script>

<style lang="less" scoped >
@import '../../assets/styles/varibles.less';

.parents{
    width: calc(100%);
    height: calc(100%);
    margin : 0px;
    // padding : 0px;
    padding-top: 2px;
    background-color: #ffffff;
    position: relative;
}

.steps{
    width: calc(100%);
    height: 6rem;
    margin : 0rem auto;
}
.steps_top{
    width: calc(100%);
    height: 4rem;
    padding: 1rem 0 1rem 0;
}
.steps_bar_size {
    width: calc(100%);
    height: calc(100%);
    background : #FEFFFF;
}


.prompt{
    width: calc(100%);
    height : 3rem;
    margin: 0rem auto;
    // background-color : #EFEFEF;
    background-color: @titleColor;
}
.prompt_title{
    width: calc(100%);
    height : 1rem;
}
.prompt_title_sub{
    width: calc(100%);
    height : 1rem;
    // color: #494949;
    color: #fff;
    font-weight: 500;
    line-height : 1rem;
    display : block;
    margin : 0rem 0 1rem 0;
    padding : 1rem 0 1rem 0;
    text-align : left ;
    text-indent : 1rem;
    font-size: 15px;
}

.plate_num{
    width:calc(100%);
    height: 19rem;
    // background: red;
    margin: 0rem auto;
}
.plate_num_input{
    width:calc(100%);
    height:5rem;
    margin: 0rem auto;
}
.plate_num_option{
    width:calc(100%);
    // height: 9rem;
    margin: 0rem auto;
}
.plate_num_outter{
    width:320px;
    height: 9rem;
    margin: 0rem auto;
}
.plate_num_outter li{
    width: 106.6px;
    height: 25px;
    float: left;
    margin-top: 20px;
}
.color_blue {
    background: url("https://static.etcmall.cn/etcissue/trucking/blue_plate.png");
    background-size: 75px 25px;
    background-repeat: no-repeat;
    
}
.color_yellow {
	background: url("https://static.etcmall.cn/etcissue/trucking/yellow_plate.png");
    background-size: 75px 25px;
    background-repeat: no-repeat;
}
.color_large_newenergy {
	background: url("https://static.etcmall.cn/etcissue/trucking/newEnergy_veh.png");
     background-size: 75px 25px;
    background-repeat: no-repeat;
}
.color_energy {
	background: url("https://static.etcmall.cn/etcissue/trucking/newEnerg.png");
     background-size: 75px 25px;
    background-repeat: no-repeat;
}
.color_black {
	background: url("https://static.etcmall.cn/etcissue/trucking/black_plate.png");
    background-size: 75px 25px;
    background-repeat: no-repeat;
}

.btn_color {
    width: 75px;
    height: 25px;
    margin: 0rem auto;
}
.hinting{
    width:calc(100%);
    height: 4rem;
    margin: 0rem auto;
}
.hintting_line{
    width:calc(100%);
    height: 2rem;
    margin: 0rem auto;
}
.hintting_sign{
    height: 1rem;
    float: left;
    margin-left: 1rem;
}
.hintting_title{
    // width: 9rem;
    height: 1rem;
    line-height: 1rem;
    color: #BABABA;
    font-size: 12px;
    font-weight: bold;
    float: left;
    text-indent: 0.4rem;
}

.but_ton{
    width: calc(100%);
    background: #fff;
    margin: 0rem auto;
    padding: 0px 0px 4px 0px;
}
.next_btn {
    width: 233px;
    text-align: center;
	background-color: #fff;
	color: #f18934;
	font-size: 15px ;
	font-weight: 400;
	height: 40px;
	margin-top: 25px;
	border-radius: 20px;
    border:1px solid #f18934;
    }
.inline_block_top {
    position: relative;
    span {
        display: block;
        position: absolute;
        top: -0.5rem;
        right: -0.5rem;
        width: 19px;
        height: 19px;
        border-radius: 50%;
        background-color: #fff;
    }
}

.cubeic-right::before {
    color: green;
    font-size: 1.2rem;
}
//  .circle {
//         width:20px;
//         height:20px;
//         border-radius:50% ;
//         background:#56A23E;
//         display:block;
//         position: relative;
//         float: right;
//         top:-10px;
//         right: -5px;
//     }

// .circle:before, .circle::after {
//         content:"";
//         height:2px;
//         width:9px;
//         border-radius: 10px;
//         display:block;
//         background:white;
//         position: absolute;
//         top:11px;/*40-6=34*/
//         left:2px;/*make the two rects in the middle of the cycle */
//         transform:rotate(45deg);    
//         -ms-transform:rotate(45deg);    
//     }
// .circle::before {
//         height:2px;
//         transform: rotate(-45deg);
//         -ms-transform:rotate(-45deg);
//         position: absolute;
//         top:10px;/*40-18=12  */
//         left:8px;       
//     }
  .show_loading {
    position: fixed;
    left: 50%;
    bottom: 50%;
    transform: translate(-50%, -50%);
  }

</style>